import { produce } from 'immer';

import {
  BOOK_SHIPPING_DONE_CONTROL_RECORD,
  BOOK_SHIPPING_ERROR_CONTROL_RECORD,
  BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD,
  CANCEL_BOOK_SHIPPING_DONE_CONTROL_RECORD,
  CANCEL_BOOK_SHIPPING_ERROR_CONTROL_RECORD,
  CANCEL_BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD,
  UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS,
  UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE,
  UPDATE_CONTROL_RECORDS,
} from '../../constants/constant_oms';
import moment from 'moment';
import { isEqual } from 'lodash';

const INIT_STATE = {
  list: [],
  book: {},
};

export default function packshipReducer(state = INIT_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case `@oms/PACKSHIP_GROUP_LINES`: {
        action.data.forEach((d) => {
          d.oms_control_records.forEach((cr) => {
            cr.picked_quantity = 0;
          });
        });
        draft.list = action.data;
        break;
      }

      case '@oms/UPDATE_PACK_CONTROL_RECORD': {
        const { list } = state;
        const { payload } = action;
        const updatedList = list.map((listItem) => {
          const controlRecords = listItem.oms_control_records.map((cr) => {
            return isEqual(cr.id, payload.id)
              ? {
                  ...payload,
                  update_time: moment().format(),
                  picked_quantity: payload.picked_quantity,
                }
              : cr;
          });

          return {
            ...listItem,
            update_time: moment().format(),
            oms_control_records: controlRecords,
          };
        });

        return {
          ...state,
          list: updatedList,
        };
      }

      case `@oms/PACKSHIP_FORM`: {
        draft.form = action.data;
        break;
      }

      case UPDATE_CONTROL_RECORDS: {
        const { payload } = action;

        payload.forEach(omcr => {
          const { sale_transaction_id } = omcr;
          const saleLine = draft.list.find(({ id: transactionLineId }) => transactionLineId === sale_transaction_id);

          if (!saleLine) return;

          saleLine.oms_control_records = saleLine.oms_control_records.map((saleLineOmcr) => {
            if (saleLineOmcr.id === omcr.id) return { ...saleLineOmcr, ...omcr };
            return saleLineOmcr;
          });
        });

        break;
      }

      case UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS: {
        const { payload } = action;
        const { id, data } = payload;
        const { delivery_address, delivery_note } = data;

        const transactionLine = draft.list.find(({ id: transactionLineId }) => transactionLineId === id);

        if (transactionLine) {
          transactionLine.delivery_address = delivery_address;
          transactionLine.delivery_note = delivery_note;
        }

        break;
      }

      case UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE: {
        const { payload } = action;
        const { id, data } = payload;
        const transactionLine = draft.list.find(({ id: transactionLineId }) => transactionLineId === id);

        if (transactionLine) {
          transactionLine.oms_control_records = transactionLine.oms_control_records.map((omcr) => ({
            ...omcr,
            st_item_ship_line: {
              ...(omcr.st_item_ship_line || {}),
              ...(data || {}),
            },
          }));
        }

        break;
      }

      case BOOK_SHIPPING_ERROR_CONTROL_RECORD:
      case BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD:
      case CANCEL_BOOK_SHIPPING_ERROR_CONTROL_RECORD:
      case CANCEL_BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD: {
        const { payload } = action;
        const { id } = payload;
        const { book } = state;
        const currBookState = book[id];
        draft.book[id] = bookReducer(currBookState, action);
        break;
      }

      case CANCEL_BOOK_SHIPPING_DONE_CONTROL_RECORD:
      case BOOK_SHIPPING_DONE_CONTROL_RECORD: {
        const { payload } = action;
        const { id, index, item } = payload;
        const { book } = state;
        const currBookState = book[id];
        draft.list[index] = item;
        draft.book[id] = bookReducer(currBookState, action);
        break;
      };

      default:
        return state;
    }
  });
}

const BOOK_INIT_STATE = {
  error: '',
  isBooking: false,
  isCancelBooking: false,
  manifestNumber: '',
  trackingNumber: '',
};

function bookReducer(state = BOOK_INIT_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD: {
        draft.error = '';
        draft.isBooking = true;
        break;
      }

      case BOOK_SHIPPING_DONE_CONTROL_RECORD: {
        draft.error = '';
        draft.isBooking = false;
        break;
      }

      case BOOK_SHIPPING_ERROR_CONTROL_RECORD: {
        const { payload } = action;
        const { error } = payload;
        draft.error = error;
        draft.isBooking = false;
        break;
      }

      case CANCEL_BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD: {
        draft.error = '';
        draft.isCancelBooking = true;
        break;
      }

      case CANCEL_BOOK_SHIPPING_DONE_CONTROL_RECORD: {
        draft.error = '';
        draft.isCancelBooking = false;
        break;
      }

      case CANCEL_BOOK_SHIPPING_ERROR_CONTROL_RECORD: {
        const { payload } = action;
        const { error } = payload;
        draft.error = error;
        draft.isCancelBooking = false;
        break;
      }

      default:
        return state;
    }
  });
}
